import Request from '../../request';
const BASE_URI_GO_API = process.env.API_GO_URL + '/api/v1';

const GetExtratoWallet = async () => {
    return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/wallet/extrato`)
}

const GetExtratoSolicitacao = async () => {
    return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/wallet/extrato/solicitacao`)
}

const GetTotalInvestido = async () => {
    return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/wallet/total/investido`)
}

const GetMeusInvestimentos = async (id) => {
    return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/investidor/meus-investimentos/${id}`)
}

const GetExtratoPaginadoWallet = async (pagina) => {
    return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/wallet/extrato/pagina/${pagina}`)
}

const GetDetalhesOperacao = async(id) => {
    return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/wallet/operacao/detalhe/${id}`)
}

const GetSaldoWallet = async() => {
    return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/wallet/saldo`)
}

const GetDadosBancariosWallet = async(userId) => {
    return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/investidor/userId/${userId}`)
}

const CreateTransfer = async(dadosSaque) => {
    return await Request.AxiosAuthPut(`${BASE_URI_GO_API}/wallet/agendamento/saque`, dadosSaque)
}

export default {
    GetExtratoWallet, 
    GetExtratoSolicitacao, 
    GetMeusInvestimentos, 
    GetExtratoPaginadoWallet, 
    GetDetalhesOperacao, 
    GetSaldoWallet, 
    GetDadosBancariosWallet, 
    CreateTransfer, 
    GetTotalInvestido
}






// WEBPACK FOOTER //
// ./src/services/api/wallet/index.js